import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isNative } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    disabled
  } = _ref;
  var keyboardFocusedBorderRadius = designContext.get('touchable-frame/keyboard-focus-corner-radius').pixelValue;
  return {
    rootStyle: {
      cursor: disabled ? 'auto' : 'pointer',
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      borderWidth: 0,
      position: 'relative',
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString(),
      width: '100%'
    },
    keyboardFocusedStyle: {
      borderRadius: keyboardFocusedBorderRadius,
      bottom: -5,
      left: -5,
      position: 'absolute',
      right: -5,
      top: -5,
      transition: 'border-color .2s ease',
      zIndex: 1,
      borderWidth: 2,
      borderColor: designContext.get('touchable-frame/keyboard-focus-border-color').toString()
    },
    wrapperStyle: _objectSpread(_objectSpread({
      opacity: disabled ? 0.4 : 1,
      zIndex: undefined
    }, isNative // workaround because Touchable (bubble-ui) behaves differently on web (button) and native (Touchable)
    ? {} : {
      height: '100%'
    }), {}, {
      flexDirection: 'row' // to make Frame inside of the wrapper full-sized
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map